/** Build & session constants */
export const BUILD_VERSION = '0.1.0';
export const GAME_TITLE = 'Odd Lab';
export const STORAGE_KEY = 'oddlab_v1';
export const ANALYTICS_KEY = 'oddlab_analytics_v1';
export const ACTIVE_MILESTONES = [10, 30, 60, 120, 300] as const;

export type DeviceClass = 'mobile' | 'tablet' | 'desktop';
export type GameMode = 'quick' | 'free' | 'challenge' | 'daily';
export type RuleId = 'normal' | 'low_gravity' | 'strong_wind' | 'bouncy_world';

export interface ViewportInfo {
  width: number;
  height: number;
  dpr: number;
}

export function detectDeviceClass(w = window.innerWidth, h = window.innerHeight): DeviceClass {
  const min = Math.min(w, h);
  const max = Math.max(w, h);
  const touch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  if (touch && max < 900) return 'mobile';
  if (touch && min < 900) return 'tablet';
  return 'desktop';
}

export function getBrowser(): string {
  const ua = navigator.userAgent;
  if (/Edg\//.test(ua)) return 'edge';
  if (/Chrome\//.test(ua) && !/Edg\//.test(ua)) return 'chrome';
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'safari';
  if (/Firefox\//.test(ua)) return 'firefox';
  return 'other';
}

export function uid(prefix = ''): string {
  const r = Math.random().toString(36).slice(2, 10);
  const t = Date.now().toString(36);
  return `${prefix}${t}_${r}`;
}

export function todayKey(d = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Deterministic daily seed from date string */
export function dailySeed(dateStr: string): number {
  let h = 2166136261;
  for (let i = 0; i < dateStr.length; i++) {
    h ^= dateStr.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
